import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";

import AS from "../Login/Service/Authentication";
import CS from "../../commons/services/Common";

import PageTitle from "../../commons/components/PageTitle";
import Modal from "../../commons/components/Modal";
import InputErrorMsgWrapper from "../../commons/components/input/InputErrorWrap";
import DeleteButton from "../../commons/components/button/DeleteButton";
import { ROUTES } from "../../commons/constants/routes/routes";

class SiteManagerEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      managerId: null,
      userName: "",
      userType: "",
      phone: "",
      email: "",
      organization: "",
      isWarningShow: false,
      validationErrors: {},
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    const managerId = window.location.pathname.split("/").pop();
    this.setState({ managerId });
    this.getSiteManagerItem(managerId);
  }

  async getSiteManagerItem(managerId) {
    try {
      const res = await axios.get(`/api/account/account/${managerId}`);
      const d = res.data;
      this.setState({
        userName: d.userName || "",
        userType: d.userType || "",
        phone: d.phone || "",
        email: d.email || "",
        organization: d.organization || "",
      });
    } catch (e) {
      console.log(e);
    }
  }

  validateForm(data) {
    const validationErrors = {};

    const password = data.get("password");
    if (password && password !== data.get("password_confirm")) {
      validationErrors.password_confirm = "패스워드가 일치하지 않습니다.";
    }

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);

    if (!this.validateForm(data)) return;

    const { managerId, userName, phone, email, organization } = this.state;

    const item = {
      id: managerId,
      // userId: phone.replace(/[^0-9]/g, ""), // 수정 시 userId는 변경하지 않음
      userName,
      userType: "USR_S",
      oldPassword:" ",
      ...(data.get("password") ? { password: data.get("password") } : {}),
      mobileCarrier: "",
      phone,
      email,
      organization,
      enabled: true,
      authorities: ["ROLE_SITE"],
      user: {
        nickName: userName,
      },
    };

    const result = await CS.update("/api/account/password-change", item);
    if (result.isSuccess) {
      this.props.history.push(ROUTES.SITE_MANAGER.MAIN);
    }
  }

  async handleDelete(e) {
    e.preventDefault();
    const result = await CS.delete(`/api/account/${this.state.managerId}`);
    if (result.isSuccess) {
      document.location.href = ROUTES.SITE_MANAGER.MAIN;
    }
  }

  closeModal = () => {
    this.setState({ isWarningShow: false });
  };

  render() {
    const { validationErrors, userName, phone, email, organization } = this.state;

    return (
      <>
        <PageTitle title="현장담당자 관리" location="현장담당자 수정" />
        <FormWrapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead>담당자명</FormHead>
              <FormBody>
                <ReadOnlyInput
                  type="text"
                  className="comm-inp"
                  value={userName}
                  readOnly
                />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>전화번호</FormHead>
              <FormBody>
                <ReadOnlyInput
                  type="text"
                  className="comm-inp"
                  value={phone}
                  readOnly
                />
                <FieldHint>로그인 ID</FieldHint>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>이메일</FormHead>
              <FormBody>
                <ReadOnlyInput
                  type="text"
                  className="comm-inp"
                  value={email}
                  readOnly
                />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>소속</FormHead>
              <FormBody>
                <ReadOnlyInput
                  type="text"
                  className="comm-inp"
                  value={organization}
                  readOnly
                />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>패스워드 변경</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.password_confirm}
                  message={validationErrors.password_confirm}
                >
                  <input
                    type="password"
                    name="password"
                    className="comm-inp"
                    placeholder="변경할 패스워드 (빈칸이면 변경 안 함)"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.password_confirm;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>패스워드 확인</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.password_confirm}
                  message={validationErrors.password_confirm}
                >
                  <input
                    type="password"
                    name="password_confirm"
                    className="comm-inp"
                    placeholder="패스워드를 다시 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.password_confirm;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>
          </FormContainer>

          <ActionRow>
            <DeleteButton type="button" onClick={this.handleDelete}>
              삭제
            </DeleteButton>
            <BtnGroup>
              <button
                type="button"
                onClick={() => this.props.history.push(ROUTES.SITE_MANAGER.MAIN)}
              >
                취소
              </button>
              <button type="submit">저장</button>
            </BtnGroup>
          </ActionRow>
        </FormWrapper>

        {this.state.isWarningShow && (
          <Modal
            icon={true}
            title="알림"
            text="처리 중 오류가 발생했습니다."
            btnGroup={false}
            closeModal={this.closeModal}
          />
        )}
      </>
    );
  }
}

const FormWrapper = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid #e3e5e7;
`;
const FormHead = styled.p`
  width: 140px;
  display: inline-block;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  ${({ required }) =>
    required &&
    `&::after {
      content: " *";
      color: #FF5353;
    }`}
`;
const FormBody = styled.div`
  display: inline-block;
  input,
  select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 436px;
  }
`;
const FieldHint = styled.span`
  display: inline-block;
  margin-left: 10px;
  font-size: 13px;
  color: #888e98;
  vertical-align: middle;
`;
const ActionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1176px;
  margin: 0 auto;
  .delete-button {
    padding: 10px 0;
  }
`;
const BtnGroup = styled.div`
  text-align: right;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:last-child {
      margin-left: 12px;
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
    }
  }
`;

const ReadOnlyInput = styled.input`
  background-color: #f5f6f8;
  color: #888e98;
  cursor: default;
  border-radius: 4px;
`;

export default SiteManagerEdit;
